export enum LiabilityTargetType {
  ITEM = "Item",
  PROPERTY = "Property",
  VEHICLE = "Vehicle"
}
